import { useState } from "react"

export const useMenu = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const isOpen = Boolean(anchorEl)
    
    const handleOpen = (e: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(e.currentTarget)
    }
    const handleClose = () => setAnchorEl(null)
    const stopPropagation = (e: React.KeyboardEvent<HTMLElement>) => {
        e.stopPropagation()
    }
    
    return {
        handleClose,
        handleOpen, 
        isOpen, 
        anchorEl,
        stopPropagation
    }
}